import React from 'react'
import AddPartner from "./AddPartner";
import AddProject from "./AddProject";
import AddNews from "./AddNews";
import MessagesAdmin from './components/MessagesAdmin';
const Admin = () => {
  return (
    <div>
        <AddPartner/>
        <AddProject/>
        <AddNews/>
        <MessagesAdmin/>
    </div>
  )
}

export default Admin